<template>
    <v-list-item
        :href="menu.route"
        :class="space ? paddingChild : 'pl-4'"
    >
        <v-list-item-icon>
            <v-icon />
        </v-list-item-icon>

        <v-list-item-title v-text="menu.name"></v-list-item-title>

        <v-list-item-icon>
            <v-icon
                v-if="menu.icon"
                v-text="menu.icon"
            />
        </v-list-item-icon>
    </v-list-item>
</template>

<script>
export default {
    props: {
        menu: {
            required: true,
            type: Object,
        },
        space: {
            type: Number
        }
    },
    computed: {
        paddingChild() {
            let level = this.space + 4
            return `pl-${level}`
        },
    },
};
</script>

<style scoped lang="scss">
.v-list-item, .v-icon {
    .v-list-item__title {
        font-weight: 400;
    }
}
</style>
